import { IconPad } from '@/components/ui/icon-pad';
import { useNavigate } from '../lib/routing';
import { HeaderContent, HEADER_TITLE_CLASS } from '../components/shell/app-header';
import { MINI_APPS } from '../lib/mini-apps-registry';
import { useRoles } from '../hooks/use-roles';

export default function MiniApps() {
  const navigate = useNavigate();
  const { activeRole, loading } = useRoles();

  const visible = activeRole
    ? MINI_APPS.filter((app) => app.availableFor.includes(activeRole as 'tutor' | 'teacher' | 'admin' | 'eleve' | 'direction'))
    : [];

  return (
    <>
      <HeaderContent width="md" showBurger>
        <div className="min-w-0">
          <h1 className={HEADER_TITLE_CLASS}>Mini-apps</h1>
          <p className="m-0 mt-0.5 text-[13px] sm:text-[13.5px] leading-snug text-muted-foreground">
            Des activités courtes pour pratiquer et progresser.
          </p>
        </div>
      </HeaderContent>
      <main className="max-w-[880px] mx-auto px-5 pb-16 pt-4">

        {loading ? (
          <p className="text-muted-foreground text-sm py-4">Chargement…</p>
        ) : visible.length === 0 ? (
          <p className="text-muted-foreground text-sm">Aucune mini-app disponible.</p>
        ) : (
          <ul className="grid grid-cols-[repeat(auto-fill,minmax(190px,1fr))] gap-3 list-none m-0 p-0">
            {visible.map((app) => (
              <li key={app.id} className="bg-card border border-border rounded-card shadow-card overflow-hidden flex flex-col">
                {app.bandeau ? (
                  <div className="w-full px-4 py-2 text-[15px] font-extrabold leading-snug bg-[var(--naia-sky)] text-naia-blue">
                    {app.bandeau}
                  </div>
                ) : null}
                <div className="flex-1 flex flex-col gap-2.5 px-4 pt-4 pb-3">
                  <IconPad variant={app.couleur ?? 'blue'} size="lg"><app.icon size={22} weight="fill" /></IconPad>
                  <div>
                    <h2 className="text-[17px] font-black text-foreground mb-[5px] mt-0 leading-[1.25]">
                      {app.title}
                    </h2>
                    {app.badge || app.nonMaintenue ? (
                      <p className="m-0 mb-[5px]">
                        <span className={`text-[10px] font-extrabold uppercase tracking-[0.05em] px-2 py-[2px] rounded-full ${
                          app.badge === 'nouveau' ? 'bg-naia-green-bg text-naia-green-deep'
                            : app.badge === 'experimental' ? 'bg-naia-info-bg text-naia-blue'
                            : 'bg-muted text-muted-foreground'
                        }`}>
                          {app.badge === 'nouveau' ? 'Nouveau'
                            : app.badge === 'experimental' ? 'Expérimental'
                            : 'Plus maintenue'}
                        </span>
                      </p>
                    ) : null}
                    {/* Trois lignes au plus : une carte doit se balayer, pas se
                        lire. Le detail est dans la mini-app, pas sur sa vignette. */}
                    <p className="text-[12.5px] text-muted-foreground m-0 leading-[1.45] line-clamp-3">
                      {app.nonMaintenue ? app.nonMaintenue.raison : app.description}
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => navigate(app.route)}
                    aria-label={`Jouer — ${app.title}`}
                    className="mt-auto px-3 py-2 rounded-sm bg-naia-blue text-card font-bold text-[13px] border-none cursor-pointer min-h-[44px]"
                  >
                    Ouvrir
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </main>
    </>
  );
}
